import { useQuery } from '@tanstack/react-query';

import { hasAnyAvailableProducts } from '@hero/utils';

import { services } from '../../services';

import { useGetAutomationProducts } from './useGetAutomationProducts';

export const useGetAutomationSpendingSummary = ({ code, products }, options) => {
  const { data: currentProducts } = useGetAutomationProducts(code);

  return useQuery(
    ['automationSpendingSummary', code, products],
    () => services.spendingSummary(code),
    {
      ...options,
      enabled: !!code && hasAnyAvailableProducts(currentProducts),
      staleTime: Infinity,
      retry: false
    }
  );
};
